import React, { useState } from 'react';
import { Button } from './button';
import { Input } from './input';
import { Field, Label } from './fieldset';
import { Heading } from './heading';
import { Text } from './text';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard/home');
    } catch (err) {
      console.error('Login error:', err);
      setError('Email o contraseña inválidos. Por favor intente de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      style={{
        background: 'linear-gradient(160deg, #1b4d2e 0%, #0d1f17 100%)',
      }}
    >
      <div className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-700/60 dark:bg-zinc-800/50">
        <img
          src="/logoH2.png"
          alt="Logo"
          className="mx-auto mb-4 h-auto"
        />
        <Heading level={1} className="text-center">
          Iniciar Sesión
        </Heading>
        <Text className="mt-2 text-center">
          Ingresa tus credenciales para acceder a tu cuenta.
        </Text>
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
          <Field>
            <Label htmlFor="email-eventobot">Email</Label>
            <Input
              id="email-eventobot"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ingresa tu email"
              required
              highlight="none"
              disabled={loading}
            />
          </Field>
          <Field>
            <Label htmlFor="password-eventobot">Contraseña</Label>
            <Input
              id="password-eventobot"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              required
              highlight="none"
              disabled={loading}
            />
          </Field>
          <Button
            type="submit"
            color="dark"
            className="w-full"
            style={{ '--btn-bg': '#1b4d2e', '--btn-border': '#163f25', '--btn-hover-overlay': 'rgba(255,255,255,0.10)' }}
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <Link
            to="/forgot-password"
            className="text-sm hover:underline"
            style={{ color: '#1b4d2e' }}
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
